import tenantApi from 'src/api/clients/tenant';
import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { MeiliSearchResponse } from 'src/types/responses/meilisearch';
import { calculatePaginationOffset } from 'src/utils/calculate-pagination-offset';
import meiliSearchApiClient from '../../../../api/clients/meilisearch';
import { DownloadEmployeesResponse } from '../../types/interfaces/download-employees.response';
import { Employee } from '../types/employee';

export const fetchEmployees = async (
  tenantToken: string,
  searchState: SearchState,
  page: number,
  perPage: number,
) => {
  const { data } = await meiliSearchApiClient.post<
    MeiliSearchResponse<Employee>
  >(`/indexes/Employee-${tenantToken}/search`, {
    ...searchState,
    limit: perPage,
    offset: calculatePaginationOffset(page, perPage),
  });

  return data;
};

export const inviteEmployee = async (email: string): Promise<void> => {
  await tenantApi.post<void>('/employees/invite', { email });
};

export const uploadEmployees = async (file: File): Promise<void> => {
  const formData = new FormData();
  formData.append('file', file, file.name);

  await tenantApi.post<void>('/employees/invite-xlsx', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const downloadEmployees =
  async (): Promise<DownloadEmployeesResponse> => {
    const { data } = await tenantApi.get<DownloadEmployeesResponse>(
      '/employees/download/xlsx',
    );

    return data;
  };

export const deleteEmployee = async (employeeToken: string): Promise<void> => {
  await tenantApi.delete<void>(`/employees/${employeeToken}`);
};

export const deleteEmployees = async (
  employeesTokens: string[],
): Promise<void> => {
  await tenantApi.post<void>('/employees/remove-bulk', { employeesTokens });
};
